<template>
  <div class="reports-index">
    <h3>Приемка работ</h3>
    <div class="type-create">
      <div class="create-new">
        <a @click="navigateToCreate(null)"
           v-if="isReportEnabledByPlan($store)"
           class="add-block">
          <el-button type="primary"> + Создать новый отчет</el-button>
        </a>
      </div>
      <i v-if="isApprove" class="el-icon-document-checked" @click="showCheck = !showCheck"></i>
      <i class="el-icon-success" @click="updateApprove" v-if="showCheck"></i>
    </div>
    <div class="search-filter">
      <div style="display: flex; flex: 1; width: 100%">
        <el-checkbox style="margin-top: 12px; margin-right: 16px; margin-left: 14px"
                     @input="setChecks"
                     v-model="isCheckedAll" v-if="showCheck"></el-checkbox>
        <el-input
          placeholder="Поиск по номеру отчета" v-model="search" @input="searchInput" class="input-search">
          <el-button slot="append" icon="el-icon-search" @click="fetchReports"></el-button>
        </el-input>
      </div>

      <div style="margin-top: 10px; margin-right: 8px; min-width: 160px;" class="filter-dialog-button">
        <el-dialog
          title="Фильтры"
          @open="getAllOptions"
          v-loading="loadingFilters"
          :visible.sync="dialogVisibleFilter"
        >
          <el-form>
            <filter-select v-model="filter.status" only-value label="Статус" :options="[
              {
              label: 'Все',
              value: null,
            },
              {
              label: 'Утвержденные',
              value: 'APPROVE',
            },
              {
              label: 'Не утвержденные',
              value: 'NOT_APPROVE',
            }
            ]">
            </filter-select>
            <filter-select v-model="filter.executor" label="Исполнитель"
                           :options="options.filter(({isCompany}) => isCompany)">

            </filter-select>
            <filter-select v-model="filter.user" label="Создатель"
                           :options="options.filter(({isCompany}) => !isCompany)">

            </filter-select>

            <filter-select multiple v-model="filter.objects" label="Объект" :options="objects"></filter-select>

            <filter-select v-model="filter.turn" label="Категория"
                           :options="shifts">

            </filter-select>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetFilter">Сбросить</el-button>
            <el-button type="primary" @click="() => {
              fetchReports()
               this.dialogVisibleFilter = false
            }">Применить</el-button>
          </span>
        </el-dialog>
        <el-button slot="reference" style="width: 100%;" @click="dialogVisibleFilter = true">Фильтры</el-button>
      </div>
      <div class="filter">
        <date-picker
          lang="ru"
          :editable="false"
          ref="datePicker"
          :close-on-select="true"
          placeholder="Фильтр по дате"
          v-model="filter.datetimeRange"
          range
          type="daterange"
          @change="changeDateTime"
          v-if="!(this.$store.state.project.plan && this.$store.state.project.plan.id)"
        ></date-picker>
        <date-picker
          lang="ru"
          popper-class="date-range"
          v-else
          style="margin-top: 8px; width: 100%;"
          :close-on-select="true"
          :picker-options="pickerOptions"
          type="daterange"
          ref="datePicker"
          clearable
          range
          :editable="false"
          v-model="filter.datetimeRange"
          @change="changeDateTime"
          placeholder="Выбрать дату">
        </date-picker>
      </div>
      <a
        v-if="$route.params.type !== 'TABEL'"
        @click="openDialog = true"
        class="filter-btn"
      >
        <el-button type="default">Выгрузить отчет</el-button>
      </a>
      <a v-else class="filter-btn">
        <el-button type="default">Выгрузить отчет</el-button>
      </a>
    </div>
    <div class="reports-ul" v-loading="loader" style="min-height: 320px">
      <a
        @click="navigateToCreate(report)"
        :key="`${report.id}_${key}`"
        class="reports-li" v-for="(report, key) in reports"
      >
        <div :class="['header-id']">
          <div style="display: flex">
            <el-checkbox
              @click.native.prevent="(e) => {
                   e.stopPropagation()
                report.isChecked = !report.isChecked
                reports = [...reports]
              }"
              :value="report.isChecked" style="margin-top: 2px; margin-right: 6px" v-if="showCheck"></el-checkbox>
            <div style="display: flex; align-items: center">
              <span style="margin-right: 8px">#{{ report.index }}</span>
              <i style="pointer-events: none" class="el-icon-success" v-if="report.approve"></i>
            </div>
            <template v-if="report.totalPrice !== undefined && report.totalPrice !== null && $store.getters.permission.price">
              <i style="color: green" class="fas fa-money-bill-wave"></i>
              <strong style="font-size: 13px; margin-left: 6px">{{ report.totalPrice }}</strong>
            </template>
          </div>
          <span>{{ report.date }}</span>
        </div>
        <span>Пользователь: <strong>{{ report.reporter ? report.reporter.name : report.user.name }}</strong></span>
        <span>Компания: <strong>{{ (report && report.user && report.user.company) || '-' }}</strong></span>
        <span>Статус: <strong>{{ (report && report.turn && report.turn.label) || '-' }}</strong></span>
      </a>
    </div>

    <ReportModal :plan="plan" :openDialog="openDialog" @close="openDialog = false"/>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import {formatEndDate, formatStartDate, getCurrentMonth} from "../../../utils/date";
import {
  getCurrentUser,
  getMyCompanyUsers,
  getPermission,
  getPermissionByUser,
  isApprove
} from "../../../firestore/permission";
import FilterSelect from "../../../components/FilterSelect";
import {isReportEnabledByPlan} from "../../../utils/permission";
import ReportModal from "./components/ReportModal";
import {getObjectOptions} from "../../../firestore/objects";
import {filterObjects} from "../../../utils/filterJobs";
import {formatNumber, pStatus} from "../../../utils/numberUtils";

export default {
  name: 'Index',
  components: {ReportModal, FilterSelect, DatePicker},
  data() {
    return {
      isCheckedAll: false,
      dialogVisibleFilter: false,
      objects: [],
      permission: null,
      loader: false,
      showCheck: false,
      isApprove: false,
      loadingFilters: false,
      shifts: [
        {
          label: 'Все',
          value: null,
        },
        {
          label: 'Принято',
          value: 'review',
        }, {
          label: 'Проверено',
          value: 'accept',
        }
      ],
      filter: {
        objects: '',
        executor: '',
        user: '',
        category: '',
        turn: {
          label: "Вce",
          value: null
        },
        status: {
          label: "Вce",
          value: null
        },
        datetimeRange: [
          new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ],
      },
      plan: {
        isTurn: true,
        isResource: true,
        isFact: true
      },
      lockNavigate: false,
      openDialog: false,
      isEnd: false,
      search: '',
      dayTurn: {
        label: 'Весь день',
        value: null,
      },
      role: 'admin',
      userSelect: {
        label: 'Все пользователи',
        value: null
      },
      options: [],
      tr: {
        COVID: 'по температуре',
        PROF: 'по численности',
        TECH: 'по технике',
        JOB: 'по работам',
        MATERIALS: 'по материалам',
        MAIN: 'общий отчет',
        WILD_PIPE: 'по сварке трубопроводов',
        TABEL: 'Табель рабочего времени'
      },
      reports: [],
    };
  },
  computed: {
    pickerOptions() {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateEnd = dayjs(year + '-' + month + '-' + '31' + ' 00:00:00').unix() * 1000

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000


        return {
          disabledDate(time) {
            return time.getTime() > unixDateEnd || time.getTime() < unixDateStart;
          },
        }
      } else {
        return {}
      }
    },
  },
  async mounted() {

    this.loader = true
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), null, true);


    this.currentUser = await getCurrentUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), true);
    this.role = this.currentUser.role;

    if (!this.$store.state.project.version) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), this.currentUser);
    }

    let filter = localStorage.getItem('ONE_REPORT' + '_' + this.$store.state.project.id);


    if (filter) {
      filter = JSON.parse(filter)

      if (!filter.datetimeRange) {
        filter.datetimeRange = []
      }

      this.filter = {
        ...this.filter,
        ...filter,
        datetimeRange: [new Date(dayjs(filter.datetimeRange[0] || null).format('YYYY-MM-DD')), new Date(dayjs(filter.datetimeRange[1] || null).format('YYYY-MM-DD'))],

      }
    } else {
      this.filter.datetimeRange = [
        new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ]


      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000
        const endDate = new Date(dayjs(unixDateStart)
          .add(1, 'month').subtract(1, 'minute').format('YYYY-MM-DD'))

        this.filter.datetimeRange = [new Date(dayjs(endDate).subtract(1, 'month').add(24, 'hour').format('YYYY-MM-DD')), endDate]
      }
    }


    if (this.$route.query.start) {
      this.filter.datetimeRange = [
        new Date(String(this.$route.query.start)),
        new Date(String(this.$route.query.end)),
      ];
    } else if (this.$store.state.project.disableDate) {
      this.filter.datetimeRange = [
        new Date(String(dayjs().subtract(365 * 10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().format('YYYY-MM-DD'))),
      ];
    }
    let query = {}

    if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
      query.plan = this.$store.state.project.plan.id;
    }


    this.userSelect = this.$route.query.user || null
    if (this.userSelect) {
      await this.fetchUsers();
      this.userSelect = JSON.parse(this.userSelect)
    }

    await this.fetchReports(10);
    this.loader = false


    this.isApprove = await isApprove(this.$store.state.project.id)

    await this.fetchReports();
    this.isEnd = true
  },

  watch: {
    '$route.query': {
      handler(response) {
        console.log('HHDHDH')
        this.fetchReports();
      },
      deep: true,
    },
    type_select() {
      if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'day').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      } else {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      }
    }
  },

  methods: {
    hostname() {
      return window.location.hostname
    },
    navigateToCreate(report) {
      if (report) {
        window.location.href = `#/dashboard/report-accept/create/${report.id}`
      } else {
        window.location.href = `#/dashboard/report-accept/create`
      }
      window.location.reload()
    },
    async getAllOptions() {
      this.loadingFilters = true
      if (!this.objects || !this.objects.length) {
        let query = {}

        if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
          query.plan = this.$store.state.project.plan.id;
        }


        this.objects = filterObjects((await getObjectOptions(this.$store.state.project.id, this.permission, query, null, 'Показать все', true)), this.permissionUser)
      }
      this.fetchUsers();
      this.userSelect = this.$route.query.user || null
      if (this.userSelect) {
        this.userSelect = JSON.parse(this.userSelect)
      }
      this.loadingFilters = false
    },
    getProfColor(form) {

      if (form.totalProfPercent) {
        return form.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }

      if (form.totalProfNorm === 0 && form.totalProfFact === 0) {
        return '#7CB342'
      } else if (form.totalProfNorm && !form.totalProfFact) {
        return '#7CB342'
      } else if (form.totalProfFact && !form.totalProfNorm) {
        return '#D32F2F'
      } else {
        return form.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }
    },
    formatNumber, pStatus,
    disabledRange(time) {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateEnd = dayjs(year + '-' + month + '-' + '31' + ' 00:00:00').unix() * 1000

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000
        return time.getTime() > unixDateEnd || time.getTime() < unixDateStart;
      } else {
        return false
      }
    },
    resetFilter() {
      this.filter = {
        objects: '',
        executor: '',
        user: '',
        category: '',
        datetimeRange: [
          new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ],
        status: {
          label: "",
          value: null
        },
      }
      localStorage.removeItem(this.$route.params.type + '_' + this.$store.state.project.id);
      this.fetchReports()
      this.dialogVisibleFilter = false
    },
    setChecks(d) {
      this.reports = this.reports.map((report) => {
        return {
          ...report,
          isChecked: d
        }
      })
    },
    async updateApprove() {
      const db = firebase.firestore();
      const projId = this.$store.state.project.id;

      // найдём текущего пользователя проекта (для approveUser.name)
      const uid = this.$store.state.company.uid || firebase.auth().currentUser.uid;

      try {
        const userSnap = await db
          .collection('projects')
          .doc(projId)
          .collection('users')
          .where('uid', '==', uid)
          .get();

        let user = null;
        userSnap.forEach((subDoc) => (user = subDoc.data()));

        const selected = (this.reports || []).filter((r) => r.isChecked);
        if (!selected.length) return;

        const batch = db.batch();

        selected.forEach((doc) => {
          const approve = !doc.approve;
          const approveUser = approve
            ? {name: (user && user.name) || firebase.auth().currentUser.email, uid: firebase.auth().currentUser.uid}
            : null;

          const reportRef = db
            .collection('projects')
            .doc(projId)
            .collection('reports_accept')
            .doc(doc.id);

          const fastRef = db
            .collection('projects')
            .doc(projId)
            .collection('reports_fast_accept')
            .doc(doc.id);

          // основной документ
          batch.update(reportRef, {
            approve,
            approveUser,
          });

          // fast-документ (обновляем только нужные поля)
          batch.set(
            fastRef,
            {
              approve,
              approveUser,
              updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            },
            {merge: true}
          );
        });

        await batch.commit();
        this.fetchReports && this.fetchReports();
      } catch (e) {
        // опционально: нотификация об ошибке
        this.$notify && this.$notify({
          offset: 60,
          title: 'Ошибка',
          message: 'Не удалось обновить статус утверждения',
          type: 'error',
        });
      }
    },
    lockHide() {
      setTimeout(() => {
        this.lockNavigate = false
      }, 800)
    },
    toReport(report) {
      if (this.lockNavigate) {
        return
      }
      this.$router.push(`/dashboard/reports/create/${report.id}/${report.type}`);
    },
    isReportEnabledByPlan,
    searchInput: _.debounce(function (el, binding) {
      this.fetchReports();
    }, 500),
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
        this.type_select = null;
        this.downloadWithPrice = false;
        this.isLaborIntensity = false;
        this.isProfession = false;
        this.isExecutor = false;
        this.downloadForAll = false;
        this.dayTurn = {
          label: 'Весь день',
          value: null,
        }
      }, 10);
    },
    sliceJob(jobs) {
      if (this.$route.params.type === 'COVID') {
        return [
          jobs,
        ];
      } else {
        return jobs ? jobs.slice(0, 3) : [];
      }
    },
    selectUser() {
      let query = {
        ...this.$route.query,
      };
      if (!this.userSelect || !this.userSelect.value) {
        delete query.user;
      } else {
        query = {
          ...this.$route.query,
          user: JSON.stringify(this.userSelect),
        };
      }
      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     ...query,
      //   },
      // });
    },
    fetchUsers() {
      return new Promise((resolve, reject) => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .get()
          .then(async (data) => {
            const result = [{label: 'Все пользователи', value: null, isCompany: 1}];
            await data.forEach((subDoc) => {
              let _data = subDoc.data();
              result.push({
                label: _data.name || _data.email,
                value: _data.uid,
                isCompany: _data.isCompany ? 1 : 0,
                _data: _data
              });
            });

            this.options = _.orderBy(_.unionBy(result, 'label'), ['isCompany'], ['desc']);
            resolve();

          }).finally(() => {
          resolve();
          this.loading = false;
        }).catch((e) => {
          this.loading = false;
        });
      })
    },
    changeDateTime() {
      localStorage.setItem('ONE_REPORT' + '_' + this.$store.state.project.id, JSON.stringify(this.filter));
      this.fetchReports();
      this.$refs.datePicker.closePopup();

    },
    sendReport() {
      const proxy = firebase.functions().httpsCallable(`onGenerateLogCommonJobs/${this.$store.state.project.id}`);
      proxy().then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отчет отправлен вам на почту',
          type: 'success',
        });
      }).catch(() => {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Произошла ошибка, попробуйте позже',
          type: 'error',
        });
      });
    },
    navigate(report) {
      this.$router.push(
        `/dashboard/reports/edit/${report.id}/${this.$route.params.type}`,
      );
    },
    async fetchReports(limit = null, skip = null) {

      return new Promise(async (resolve) => {
        localStorage.setItem('ONE_REPORT' + '_' + this.$store.state.project.id, JSON.stringify(this.filter));

        let query = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports_fast_accept');

        const filterArray = [
          ['type', '==', 'ONE_REPORT'],
        ];

        if (this.search) {
          filterArray.push(
            ['index', '==', Number(this.search)],
          );
        }

        if (this.$store.state.company.uid) {
          filterArray.push(
            ['userId', '==', this.$store.state.company.uid],
          );
        }

        if (this.$route.query.start && this.$route.query.end) {
          filterArray.push(
            ['dateunix', '<', formatEndDate(this.$route.query.end)],
          );
          filterArray.push(
            ['dateunix', '>', formatStartDate(this.$route.query.start)],
          );
        } else {
          filterArray.push(
            ['dateunix', '<', formatEndDate(this.filter.datetimeRange[1])],
          );
          filterArray.push(
            ['dateunix', '>', formatStartDate(this.filter.datetimeRange[0])],
          );
        }

        query = filterArray.reduce((accQuery, filter) => {
          return accQuery.where(filter[0], filter[1], filter[2]);
        }, query).orderBy('dateunix', 'desc').orderBy('index', 'desc');


        if (skip) {
          query = query.startAfter(skip);
        }

        if (limit) {
          query = query.limit(limit);
        }
        let usersIds = []

        if (this.role === 'editor') {
          usersIds = await getMyCompanyUsers(this.$store.state.project.id);
        }


        query.get()
          .then(async (data) => {
            const result = [];
            this.reports = [];

            data.forEach((subDoc) => {
              const data = subDoc.data()

              if (this.role === 'worker' &&

                (!data.reporter || data.reporter.uid !== firebase.auth().currentUser.uid && data.userId !== firebase.auth().currentUser.uid)
              ) {
                return
              } else {
                // if (this.permission && this.permission.available_objects && (data.reporter.uid !== firebase.auth().currentUser.uid && data.userId !== firebase.auth().currentUser.uid)) {
                //   const objects = this.objects.map(({value}) => value)
                //
                //   if (!data.object || !data.object.id || !objects.includes(data.object.id)) {
                //     return
                //   }
                // }
              }


              if (this.filter.user && this.filter.user.value) {
                if (data.reporter.uid !== this.filter.user.value) {
                  return false
                }
              }


              if (this.filter.turn && this.filter.turn.value) {
                if (data.turn.value !== this.filter.turn.value) {
                  return false
                }
              }


              let user = this.filter.executor
              if (this.filter.executor && this.filter.executor.value) {
                const company = this.options.find((d) => d.value === user.value && d.isCompany);

                if (data.user.uid !== user.value && (!company || !company._data || company._data.company !== data.user.company)) {
                  return
                }
              }


              // if(this.filter.executor && this.filter.executor.value) {
              //   if(data.user.uid !== this.filter.executor.value) {
              //     return false
              //   }
              // }

              if (this.filter.status) {
                if (data.approve && this.filter.status === 'NOT_APPROVE') {
                  return false
                }

                if (!data.approve && this.filter.status === 'APPROVE') {
                  return false
                }
              }


              if (this.filter.objects && this.filter.objects.length) {
                const objectsInput = data.inputObjects.map(({id}) => id);

                const objects = this.filter.objects.map(({value}) => value)


                if (!objects.includes(null)) {
                  if (!objectsInput.find(id => objects.includes(id))) {
                    return;
                  }
                }
              }

              let planId = data.planId;

              if (!planId) {
                try {
                  planId = data.jobs[0].job.planID;
                } catch (e) {
                  try {
                    planId = data.jobs[0][0].job.planID;
                  } catch (e) {
                  }
                }
              }

              if (data.planId === undefined) {
                return result.push({
                  ...data,
                  index: data.index,
                  id: subDoc.id,
                  object: data.object && data.object.name,
                  date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
                  jobs: data.jobs,
                });
              }


              if (this.$store.state.project.plan && planId === this.$store.state.project.plan.id) {
                return result.push({
                  ...data,
                  index: data.index,
                  id: subDoc.id,
                  object: data.object && data.object.name,
                  date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
                  jobs: data.jobs,
                });
              }

              if ((!this.$store.state.project.plan || !this.$store.state.project.plan.id) && !planId) {
                return result.push({
                  ...data,
                  index: data.index,
                  id: subDoc.id,
                  object: data.object && data.object.name,
                  date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
                  jobs: data.jobs,
                });
              }
            });

            if (this.role === 'editor') {
              this.reports = result.filter((r) => usersIds.includes(r.userId) || usersIds.includes(r.reporterId) || usersIds.includes(r.company) || usersIds.includes(r.reporter.company));
            } else {
              this.reports = result;
            }

            const savedReports = _.orderBy(this.reports, ['internalIndex'], ['asc']);
            this.reports = savedReports.map((report) => {
              report.objects = []
              const internal = this.reports.filter(({
                                                      id,
                                                      index,
                                                      object
                                                    }) => index === report.index && id !== report.id && report.object !== object);

              if (internal) {
                const objects = _.orderBy(internal, ['internalIndex'], ['asc'])
                report.objects = objects.map(({object}) => object)
              }

              return report
            })

            this.reports = _.orderBy(_.orderBy(this.reports.map((report) => {
              return {
                ...report,
                dateunix: dayjs(dayjs(report.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix()
              }
            }), ['index'], ['desc']), 'dateunix', ['desc']);

            resolve()
          });

      })
    },
  }
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.input-search {
  margin-top: 10px;
}

.reports-li {
  display: flex;
  cursor: pointer;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  padding: 10px 14px;
  text-decoration: none;
  color: #000;

  span {
    text-align: left;
  }

  &--child {
    width: 100%;
    display: flex;
    text-decoration: none;
    cursor: pointer;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;

  }

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

> > > .el-date-editor--daterange.el-input__inner {
  width: 100%;
  margin-top: 10px;
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;

  .input-search {
    margin-right: 10px;
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

.is_mobile {
  display: flex;
}

.is_desktop {
  display: none;
}

@media screen and (max-width: 764px) {

  .is_mobile {
    display: none;
  }

  .is_desktop {
    display: flex;
  }


  .el-date-range-picker .el-picker-panel__body {
    min-width: 256px !important;
  }


  .filter-dialog-button {
    width: 100% !important;
  }
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: auto;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  margin-top: 10px;
  margin-right: 5px;
}

.disabled {
  opacity: 0.7;
}

.mb-1 {
  margin-bottom: 10px;
}


.create-new {
  display: flex;
  align-items: center;

  .add-block button {
    margin-top: 0 !important;
  }
}

.type-create {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  i {
    margin-left: 16px;
    font-size: 28px;
    cursor: pointer;
  }
}

.el-icon-success {
  color: #2ecc71;
}

.progress-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #13ce66;
  min-width: 28px;
  height: 28px;
  padding-left: 1px;
  padding-right: 1px;
  border-radius: 16px;
  border: 1px solid #13ce66;
}

</style>
<style lang="scss">
@media screen and (max-width: 764px) {

  .el-date-range-picker .el-picker-panel__body {
    min-width: 256px !important;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }

  .el-date-range-picker__content {
    width: 100% !important;
  }

  .el-date-range-picker {
    width: 323px !important;
  }
}

.reports-index {
  .mx-datepicker-range {
    width: 100%;
    margin-top: 10px;

    .mx-input {
      border: 1px solid #DCDFE6;
      height: 40px;
    }
  }
}


.search-filter {
  .filter-worker {
    width: 100%;

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOneComplete/List.vue